import { settingsService } from '@/services'
import localStorageService from '@/core/local-storage'

export default {
  state: {
    settings: {
      columnWidth: 'Normal',
      fontFamily: 'Inter',
      fontSize: 'Large',
      mode: 'Paperless',
      theme: 'Magenta',
      bookView: 'Card',
      lineHeight: '1.6',
      taskOrdering: true
    },
    dateFormat: localStorageService.getItem('dateFormat') || { id: 1, name: 'DD.MM.YYYY' },
    defaultProjectIcon: localStorageService.getItem('default-icon') || 'purple_circle',
    showHeader: true,
    showBackButton: true,
    showSidebar: false,
    showSettingsModal: false,
    activeState: 'Account',
    isFocusMode: false,
    showAside: false,
    previousTheme: null,
    previousDarkTheme: null,
    isGrammarCheck: localStorageService.getItem('grammarCheck') || false,
    isAutoSwitchingThemeEnable: localStorageService.getItem('auto-switching-theme') || false
  },

  getters: {
    isDarkMode (state) {
      return state.settings.theme.includes('Dark') || state.settings.theme === 'Dracula'
    },

    isHueTheme (state) {
      return state.settings.theme.includes('Light')
    },

    isTwilightTheme (state) {
      return state.settings.theme.includes('Dark')
    },

    isMagenta (state) {
      return state.settings.theme === 'Magenta'
    },

    isDraculaTheme (state) {
      return state.settings.theme === 'Dracula'
    },

    isPoseidonTheme (state) {
      return state.settings.theme === 'Poseidon'
    },

    isPaperShape (state) {
      return state.settings.mode === 'Paper shape'
    }
  },

  mutations: {
    updateSettings (state, value) {
      state.settings = value
    },

    resetSettings (state) {
      state.settings = {
        columnWidth: 'Normal',
        fontFamily: 'Inter',
        fontSize: 'Large',
        mode: 'Paperless',
        theme: 'Magenta',
        bookView: 'Card',
        lineHeight: '1.6',
        taskOrdering: true
      }
      state.activeState = 'Account'
    },

    updateSidebar (state, value) {
      state.showSidebar = value
    },

    updateHeader (state, value) {
      state.showHeader = value
    },

    updateBackButton (state, value) {
      state.showBackButton = value
    },

    toggleSettingsModal (state, value) {
      state.showSettingsModal = value
    },

    changeActiveState (state, value) {
      state.activeState = value
    },

    setFocusMode (state, value) {
      state.isFocusMode = state.showSidebar ? false : value
    },

    toggleAside (state, value) {
      state.showAside = value
    },

    updatePreviousTheme (state, value) {
      state.previousTheme = value
    },

    updatePreviousDarkTheme (state, value) {
      state.previousDarkTheme = value
    },

    updateGrammarCheck (state, value) {
      localStorageService.setItem('grammarCheck', value)
      state.isGrammarCheck = value
    },

    updateDateFormat (state, value) {
      localStorageService.setItem('dateFormat', value)
      state.dateFormat = value
    },

    updateAutoSwitchingTheme (state, value) {
      localStorageService.setItem('auto-switching-theme', value)
      state.isAutoSwitchingThemeEnable = value
    },

    updateDefaultIcon (state, value) {
      localStorageService.setItem('default-icon', value)
      state.defaultProjectIcon = value
    }
  },

  actions: {
    getSettings ({ commit }) {
      commit('loading', true)
      settingsService.getSettings().then(({ data }) => {
        commit('updateSettings', data.settings)
      })
    }
  }
}
